import { render, staticRenderFns } from "./AiActionButton.vue?vue&type=template&id=c3a2834c&scoped=true"
import script from "./AiActionButton.vue?vue&type=script&lang=js"
export * from "./AiActionButton.vue?vue&type=script&lang=js"
import style0 from "./AiActionButton.vue?vue&type=style&index=0&id=c3a2834c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a2834c",
  null
  
)

export default component.exports